import { render, staticRenderFns } from "./ForestVision2020English.vue?vue&type=template&id=0e503ec8&scoped=true"
import script from "./ForestVision2020English.vue?vue&type=script&lang=js"
export * from "./ForestVision2020English.vue?vue&type=script&lang=js"
import style0 from "./ForestVision2020English.vue?vue&type=style&index=0&id=0e503ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e503ec8",
  null
  
)

export default component.exports